import React, { useEffect, useMemo, useState } from "react";
import TitlePage from "../../../components/TitlePage";
import { Row, Col, Button, Form, InputGroup} from "react-bootstrap";
import { ConsultaTotvsEmpresa, ConsultaTotvsEmpresaIndividual } from "../../../../backend/ConsultaTotvsEmpresa";
import ResponsiveDataTable from "../../../components/DataTable";
import LoadingSpinner from "../../../components/LoadinSpinner";
import InputGeral from "../../../components/InputGeral/Index";
import SelectFixo from "../../../components/SelectFixo";

import PedidoCompra from "../../../../lib/json/consultas/PedidoCompra.json"
import SelectUsuario from "../../../components/Select/Usuario";
import SelectEmpresa from "../../../components/Select/Empresa";
import SelectCentroCusto from "../../../components/Select/CentroCusto";
import SelectComprador from "../../../components/Select/Comprador";
import { ErroMsg, optionsStatusPC, RetornaUsuarioLogado, SucessoMsg } from "../../../contents/VariaveisGlobais";
import { useNavigate } from "react-router-dom";
import { format, startOfMonth, startOfYear } from "date-fns";
import { usePopUp } from "../../../components/BootBox";
import { handleData, handleValorTotal } from "../../../components/GridCell/Preco";
import { handleFornecedorPCColumn, handleNumeroPCColumn, handleSaldoPC, handleStatusEnvioPCExcel, handleStatusPC, handleStatusPCExcel } from "../../../components/GridCell/Pedido";
import SelectFornecedor from "../../../components/Select/Fornecedor";
import ConsumoTOTVS_POST from "../../../../backend/ConsumoTotvs";
import DisparaEmail from '../../../../backend/DisparaEmail';
import PedidoCompraPDF from "../PedidoCompraPDF";
import { ConsultaAPI_URL } from "../../../../backend/ConsultaAPI";
import { useSessionStorageState } from "../../../../hooks/useSessionStorageState";
import ExportarExcel from "../../../components/ExportarExcel";
import getAnexoFromUrl from "../../../../utils/anexoUrl";

function ListaPedidosCompra(){
    const { DisparaBootBox, FechaBootBox  } = usePopUp();
    // define a exibição do Loading
    var tabelasDefault  = PedidoCompra.tabelas;
    
    const navigate = useNavigate();
    const currentDate = new Date()
    const firstDayOfMonthDate = startOfMonth(currentDate);
    const usuarioLogado = RetornaUsuarioLogado()
    const usuarioProtheus = usuarioLogado.usuarioProtheus
    const usuarioComprador = (usuarioProtheus?.value || '');
    
    const options = optionsStatusPC
    const optionsEnvio = [
        {
            value: '0',
            text: "Todos",
            filtroSQL: "( 1 = 1 )"
        },
        {
            value: '1',
            text: "Não Enviado",
            filtroSQL: "( C7_XENVTET NOT IN ('E','R') )"
        },
        {
            value: '2',
            text: "Enviado",
            filtroSQL: "( C7_XENVTET = 'E' )"
        },
        {
            value: '3',
            text: "Lido",
            filtroSQL: "( C7_XENVTET = 'R' )"
        }
    ]

    const [carregar, setCarregar] = useState(false);
    const [data, setData]   = useState([]);
    const [empresa, setEmpresa] = useSessionStorageState("pedidoEmpresa",{value: '', text: ''});
    const [pedidoCompra, setPedidoCompra] = useSessionStorageState("pedidoNumero",'');
    const [solicitacao, setSolicitacao] = useSessionStorageState("pedidoSolicitacao",'');
    const [cotacao, setCotacao] = useSessionStorageState("pedidoCotacao",'');
    
    const [dateDe, setDateDe] = useSessionStorageState("pedidoDataDe",format(firstDayOfMonthDate, 'yyyy-MM-dd'));
    const [dateAte, setDateAte] = useSessionStorageState("pedidoDataAte",format(currentDate, 'yyyy-MM-dd'));
    const [campoSolicitante, setCampoSolicitante] = useSessionStorageState("pedidoSolicitante",null);
    const [campoFornecedor, setCampoFornecedor] = useSessionStorageState("pedidoFornecedor",null);
    const [campoComprador, setCampoComprador] = useSessionStorageState("pedidoComprador",{value: usuarioComprador, label: ''});
    const [campoCentroCusto, setCampoCentroCusto] = useSessionStorageState("pedidoCentroCusto",null);
    const [campoStatus, setCampoStatus] = useSessionStorageState("pedidoStatus",options[3]);
    const [campoStatusEnvio, setCampoStatusEnvio] = useSessionStorageState("pedidoStatusEnvio",optionsEnvio[0]);
    const [disabledComprador, setDisabledComprador] = useState(!usuarioLogado.permissao.visualizarPedidoCompra)    

    var empresaCopiar = {value: '', text: ''};
    var scOrigem = '';
    var empresaOrigem = '';

    const excelColumns = [
        {
          Header: 'Filial',
          accessor: "C7_FILIAL",          
        },
        {
          Header: 'Pedido',
          accessor: "C7_NUM",          
        },
        {
          Header: 'Cotação',
          accessor: "C7_NUMCOT",          
        },
        {
          Header: 'Solicitação Compra',
          accessor: "C7_NUMSC",          
        },
        {
          Header: 'Fornecedor',
          accessor: "C7_FORNECE",          
        },
        {
          Header: 'Loja Fornecedor',
          accessor: "C7_LOJA",          
        },
        {
          Header: 'Nome Fornecedor',
          accessor: "A2_NOME",          
        },
        {
          Header: 'CNPJ Fornecedor',
          accessor: "A2_CGC",          
        },
        {
          Header: 'E-mail Fornecedor',
          accessor: "EMAIL",          
        },
        {
          Header: 'Emissão',
          accessor: 'C7_EMISSAO',
          Cell: handleData
        },
        {
          Header: 'Previsão',
          accessor: 'C7_DATPRF',
          Cell: handleData
        },
        {
          Header: 'Comprador',
          accessor: 'C7_COMPRA',
        },
        {
          Header: 'Nome Comprador',
          accessor: 'Y1_NOME',
        },
        {
          Header: 'Saldo',
          accessor: 'SALDO',
          Cell: handleValorTotal
        },
        {
          Header: 'Total',
          accessor: 'C7_TOTAL',
          Cell: handleValorTotal
        },
        {
          Header: 'Status',
          accessor: 'C7_CONAPRO',
          Cell: handleStatusPCExcel
        },
        {
          Header: 'Status Envio',
          accessor: 'C7_CONAPRO',
          Cell: handleStatusEnvioPCExcel
        }
    ]

    // Colunas do grid
    const columns = [
        {
          Header: 'PC',
          accessor: "C7_FILIAL",
          Cell: (item) => handleNumeroPCColumn(item, DisparaBootBox, FechaBootBox, navigate)
        },
        {
          Header: 'Fornecedor',
          accessor: "C7_FORNECE",
          Cell: handleFornecedorPCColumn
        },
        {
          Header: 'Emissão',
          accessor: 'C7_EMISSAO',
          Cell: handleData
        },
        {
          Header: 'Previsão',
          accessor: 'C7_DATPRF',
          Cell: handleData
        },
        {
          Header: 'Saldo/Total',
          accessor: 'SALDO',
          Cell: (item) => handleSaldoPC(item, DisparaBootBox, FechaBootBox)
        },
        {
          Header: 'Status',
          accessor: 'C7_CONAPRO',
          Cell: handleStatusPC
        }
    ];

    // WHERE/filtros da consulta do grid
    const retornaConsultaDefault = () => {
        let consultaDefault = PedidoCompra.consulta;
        let consultaFiltro = ' ';
        
        consultaFiltro += "AND C7_FILIAL = FILIAL(SC7) ";
        
        if(pedidoCompra) {
            consultaFiltro += "AND C7_NUM = '"+pedidoCompra+"' ";
        }
        if(solicitacao) {
            consultaFiltro += "AND C7_NUMSC = '"+solicitacao+"' ";
        }
        if(cotacao) {
            consultaFiltro += "AND C7_NUMCOT = '"+cotacao+"' ";
        }
        if(dateDe) {
            consultaFiltro += "AND C7_EMISSAO >= '"+dateDe.replaceAll('-','')+"' ";
        }
        if(dateAte) {
            consultaFiltro += "AND C7_EMISSAO <= '"+dateAte.replaceAll('-','')+"' ";
        }
        if(campoSolicitante?.value) {
            consultaFiltro += "AND C7_FILIAL + C7_NUM IN (SELECT DISTINCT C1_FILIAL + C1_PEDIDO FROM TABELA(SC1) SC1 WHERE SC1.D_E_L_E_T_ <> '*' AND C1_PEDIDO <> '' AND C1_USER = '"+campoSolicitante.value+"' GROUP BY C1_FILIAL + C1_PEDIDO ) ";
        }
        if(campoFornecedor?.value) {
            consultaFiltro += "AND C7_FORNECE + C7_LOJA = '"+campoFornecedor.value+"' ";
        }
        if(campoStatus?.filtroSQL) {
            consultaFiltro += "AND "+campoStatus.filtroSQL+" ";
        }
        if(campoStatusEnvio?.filtroSQL) {
            consultaFiltro += "AND "+campoStatusEnvio.filtroSQL+" ";
        }
        if(campoCentroCusto?.value) {
            consultaFiltro += "AND C7_FILIAL + C7_NUM IN (SELECT DISTINCT C7A.C7_FILIAL + C7A.C7_NUM FROM TABELA(SC7) C7A WHERE C7A.D_E_L_E_T_ <> '*' AND C7A.C7_FILIAL = FILIAL(SC7) AND C7A.C7_CC = '"+campoCentroCusto.value+"' " + consultaFiltro.replaceAll('C7_','C7A.C7_') + " ) ";
        }
        if(campoComprador?.value) {
            consultaFiltro += "AND Y1_USER = '"+campoComprador.value+"' ";
        }

        //Implementar Regra Filtragem Empresa x CC
        
        return consultaDefault.replace('FILTRO', consultaFiltro)
    }

    // Processa consulta do grid
    const listaPC = async () => {
        var consultaDefault = retornaConsultaDefault();
        let empresaFilial = empresa.value ? empresa.value.substr(0,window._env_?.REACT_APP_TAMANHO_EMPRESA) + '-' + empresa.value.substr(-window._env_?.REACT_APP_TAMANHO_FILIAL) : ''

        setCarregar(true);
        var retConsulta = await ConsultaTotvsEmpresaIndividual( consultaDefault, tabelasDefault, empresaFilial );
        
        if (retConsulta.error === '00'){
            setData(retConsulta.data);
        }

        setCarregar(false);
    }

    const enviarEmailPC = async() => {
        const dataEmail = data.filter( (item) => item.Check === true );
        const anexoEmailPC = await getAnexoFromUrl(
            "uploads/email/Novo_Portal_NFs.pdf",
            "Novo Portal de NFS.pdf"
        );

        setCarregar(true)
        const dataPromisse = await Promise.all(
            dataEmail.map( async(item) => {
                let PedidoPDF = await PedidoCompraPDF( item.C7_NUM.trim(), item.EMPRESA, item.C7_FILIAL)
                
                let dadosEnvio = {
                    showMsg: true,
                    destinatario: item.EMAIL,
                    assunto: 'Pedido de Compra',
                    corpo: `<p>Prezado(a) ${item.C7_CONTATO},</p>
                    <p>Espero que este e-mail o(a) encontre bem.</p>
                    <p>Gostaríamos de informar que seu pedido de compra, referente ao número ${item.C7_NUM.trim()}, foi revisado e aprovado. Agradecemos sua paciência durante o processo de análise.</p>
                    <p>Anexado a este e-mail, por favor, encontra-se o pedido de compra aprovado em formato PDF para sua referência. Por favor, verifique todos os detalhes do pedido, incluindo quantidades, preços e prazos de entrega.</p>
                    <p>Por favor, esteja ciente de que ao proceder com este pedido, você concorda com os termos e condições estabelecidos no documento anexo.</p>
                    <p>Se você tiver alguma dúvida ou precisar de esclarecimentos adicionais, não hesite em entrar em contato conosco. Estamos à disposição para ajudá-lo(a) no que for necessário.</p>
                    <img src="${window._env_?.REACT_APP_URL}:${window._env_?.REACT_APP_PORT}/api/rastreamento/email/pedido?empresa=${item.EMPRESA}&filial=${item.C7_FILIAL}&pedido=${item.C7_NUM.trim()}&status=R" width="1" height="1" />
                    <p>Agradecemos sua cooperação.</p>`,
                    anexos: [ { anexo: PedidoPDF, nome: `Pedido Compra - ${item.C7_NUM.trim()}.pdf` },
                        ...(anexoEmailPC?.anexo ? [anexoEmailPC] : [])
                    ],
                    sender: usuarioLogado.email,
                }
                
                await DisparaEmail(dadosEnvio);
                const retAPI = await ConsultaAPI_URL(`rastreamento/email/pedido?empresa=${item.EMPRESA}&filial=${item.C7_FILIAL}&pedido=${item.C7_NUM.trim()}&status=E`)
                
                return retAPI
            })
        )

        setCarregar(false)
    }

    useEffect( () => {
        listaPC()
    },[])

    const handleAlterar = (row) =>{
        navigate(`./Alterar/${row.original.C7_NUM}/${row.original.EMPRESA}${row.original.C7_FILIAL}`)
    }
    
    const handleVisualizar = (row) =>{
        navigate(`./Visualizar/${row.original.C7_NUM}/${row.original.EMPRESA}${row.original.C7_FILIAL}`)
    }

    const handleCopiar = (row) =>{
        const idRow = row.original.C7_NUM;
        const Mensagem = ( <>
                <SelectEmpresa
                    campoEmpresa={empresaCopiar}
                    onChangeEmpresa={(e) => {empresaCopiar = e}}
                />
            </>
        )
        
        const buttonsRender = [
            { variant: 'primary', action: handleConfirmaCopiar, label: 'Confirmar' },
            { variant: 'secondary', action: FechaBootBox, label: 'Cancelar' }
        ]
        
        scOrigem = row.values.C7_NUM;
        empresaOrigem = row.original.EMPRESA + '' + row.original.C7_FILIAL;

        DisparaBootBox('Confirmar Copia para Filial Escolhida ?', Mensagem, buttonsRender, idRow, null)
    }

    const handleConfirmaCopiar = () => {  
        FechaBootBox()
        navigate(`./Copiar/${scOrigem}/${empresaOrigem}/${empresaCopiar.value}`)
    }
    
    const handleExcluir = async (row) => {
        const idRow = row.original.EMPRESA + '' + row.original.C7_FILIAL + '|' + row.original.C7_NUM;
        const Mensagem = `Tem certeza que deseja excluir o Pedido ${row.original.C7_NUM + ' - da Filial: ' + row.original.C7_FILIAL}?`
        
        DisparaBootBox('Confirma Exclusão ?', Mensagem, null, idRow, handleExcluirConfirm)
    };
    
    const handleResiduo = async (row) => {
        const idRow = row.original.EMPRESA + '' + row.original.C7_FILIAL + '|' + row.original.C7_NUM;
        const Mensagem = `Tem certeza que deseja Eliminar Resíduo do Pedido ${row.original.C7_NUM + ' - da Filial: ' + row.original.C7_FILIAL}?`
        
        DisparaBootBox('Confirma Eliminação de Resíduo ?', Mensagem, null, idRow, handleResiduoConfirm)
    };

    const handleExcluirConfirm = async(row) => {
        const empresaFilial = row.split('|')[0]
        const cJSONSalvar = { Numero: row.split('|')[1] }

        FechaBootBox()
        try {
            setCarregar(true);

            const oRetorno = await ConsumoTOTVS_POST('EXCLUIRPEDIDOCOMPRAS', cJSONSalvar, empresaFilial)
            
            if (oRetorno.error === '00'){
                SucessoMsg(oRetorno.description)
            }else{
                ErroMsg(oRetorno.description)
                return false;
            }
        } catch (error) {
            console.error('Error in handleExcluir:', error);
            // Handle the error, show an error message, or log it as needed.
        } finally {
            setCarregar(false);
            listaPC();
        }
    };
    
    const handleResiduoConfirm = async(row) => {
        const empresaFilial = row.split('|')[0]
        const cJSONSalvar = { Numero: row.split('|')[1] }

        FechaBootBox()
        try {
            setCarregar(true);

            const oRetorno = await ConsumoTOTVS_POST('ELIMINARESIDUO', cJSONSalvar, empresaFilial)
            
            if (oRetorno.error === '00'){
                SucessoMsg(oRetorno.description)
            }else{
                ErroMsg(oRetorno.description)
                return false;
            }
        } catch (error) {
            console.error('Error in handleExcluir:', error);
            // Handle the error, show an error message, or log it as needed.
        } finally {
            setCarregar(false);
            listaPC();
        }
    };

    const excelHeaders = useMemo(() => {
        return excelColumns.map(col => col.Header);
    }, [excelColumns]);

    const excelRows = useMemo(() => {
        return data.map(item =>
            excelColumns.map(col => {
                const value = item[col.accessor];

                if (col.Cell) {
                    return col.Cell({ value, row: { original: item } });
                }
                return value ?? ""; // valor padrão se undefined/null
            })
        );
    }, [data, excelColumns]);

    return (
        <>
            <Row>
                <LoadingSpinner isLoading={carregar}/>
                <Col md="12" xs="12">
                    <TitlePage text="Pedido de Compras"/>
                </Col>
                <Col md='4'>
                    <SelectEmpresa
                        campoEmpresa={empresa}
                        onChangeEmpresa={setEmpresa}
                    />
                </Col>
                <Col md="8" xs="12">
                    <SelectFornecedor
                        campoFornecedor={campoFornecedor}
                        changeFornecedor={setCampoFornecedor}
                        empresaLogada={empresa.value}
                    />
                </Col>
            </Row>
            <Row>
                <Col md="2" xs="12">
                    <InputGeral 
                        label="Pedido"
                        tipo='text'
                        max="6"
                        value={pedidoCompra}  // Define o valor do campo com base no estado
                        onChange={(e) => setPedidoCompra(e.target.value)}
                    />
                </Col>
                <Col md="2" xs="12">
                    <InputGeral 
                        label="Cotação"
                        tipo='text'
                        max="6"
                        value={cotacao}  // Define o valor do campo com base no estado
                        onChange={(e) => setCotacao(e.target.value)}
                    />
                </Col>
                <Col md="2" xs="12">
                    <InputGeral 
                        label="Solicitação de Compra"
                        tipo='text'
                        max="6"
                        value={solicitacao}  // Define o valor do campo com base no estado
                        onChange={(e) => setSolicitacao(e.target.value)}
                    />
                </Col>
                <Col md="3" xs="12">
                    <InputGeral
                        label="Emissão de"
                        tipo='date'
                        value={dateDe}
                        onChange={(e) => setDateDe(e.target.value)}
                    />
                </Col>
                <Col md="3" xs="12">
                    <InputGeral
                        label="Emissão até"
                        tipo='date'
                        value={dateAte}
                        onChange={(e) => setDateAte(e.target.value)}
                    />
                </Col>
                <Col md="4" xs="12">
                    <SelectUsuario
                        campoUsuario={campoSolicitante}
                        onChangeUsuario={setCampoSolicitante}
                    />
                </Col>
                <Col md="4" xs="12">
                    <SelectComprador
                        campoComprador={campoComprador}
                        changeComprador={setCampoComprador}
                        empresaLogada={empresa.value}
                        disabled={disabledComprador}
                    />
                </Col>
                <Col md="4" xs="12">
                    <SelectCentroCusto 
                        campoCentroCusto={campoCentroCusto}
                        changeCentroCusto={setCampoCentroCusto}
                        empresaLogada={empresa.value}
                    />
                </Col>
                <Col md="4" xs="12">
                    <SelectFixo 
                        options={options} 
                        value={campoStatus} 
                        selectedOptionValue={campoStatus}
                        isLabel={true} 
                        label="Status" 
                        onChange={(e) => setCampoStatus(e)}
                    />
                </Col>
                <Col md="4" xs="12">
                    <SelectFixo 
                        options={optionsEnvio} 
                        value={campoStatusEnvio} 
                        selectedOptionValue={campoStatusEnvio}
                        isLabel={true} 
                        label="Status Envio" 
                        onChange={(e) => setCampoStatusEnvio(e)}
                    />
                </Col>
            </Row>
            <Row className="d-flex justify-content-end">
                <Col md="3" xs="12">
                    <Button variant="outline-primary" type="submit" className="w-100" onClick={listaPC}>
                        Buscar
                    </Button>
                </Col>
                
                { usuarioComprador !== '' && (
                    <Col md="3" xs="12">
                        <Button variant="outline-success" type="submit" className="w-100" onClick={enviarEmailPC}>
                            Enviar E-mail
                        </Button>
                    </Col>
                )}

                <Col md="3" xs="12">
                    <ExportarExcel 
                        nomeArquivo="Pedidos"
                        headers={excelHeaders}
                        rows={excelRows}
                    />
                </Col>
            </Row>
            
            <Row>
                <Col md="12" xs="12">
                    <ResponsiveDataTable 
                        linhaCondicional={(item) => item.EMERGENCIAL != 0}
                        columns={columns} 
                        data={data} 
                        buttons={[
                            {isVisual: true, action: handleVisualizar, label: "Visualizar", icone: "MdOutlinePreview", style: "light"}, 
                            {isAlterar: true, action: handleAlterar, label: "Alterar", icone: "MdOutlineEditNote", regraExclude: "( row.original.SALDO !== row.original.C7_TOTAL )"}, 
                            {isExcluir: true, action: handleResiduo, label: "Eliminar Residuo", icone: "MdPlayDisabled", regraExclude: "( row.original.SALDO == 0 )", style: "warning"},
                            {isExcluir: true, action: handleExcluir, label: "Excluir", icone: "MdPlaylistRemove", regraExclude: "( row.original.SALDO !== row.original.C7_TOTAL )", style: "danger"},
                        ]}
                        habilitaCheckBox={usuarioComprador !== ''}
                        condicionalCheck="
                        const validateEmail = (emailString) => {
                            const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                            const emails = emailString.split(';').map(e => e.trim()).filter(e => e !== '');

                            const invalidEmails = emails.filter(email => !regex.test(email));

                            if (invalidEmails.length > 0) {
                                ErroMsgGlobal(`E-mail(s) inválido(s): ${invalidEmails.join(', ')}`);
                                return false;
                            }

                            return true;
                        };
                        ( validateEmail(data[rowIndex].EMAIL.trim()) && (data[rowIndex].C7_CONAPRO.trim() === '' || data[rowIndex].C7_CONAPRO.trim() === 'L') && Number(data[rowIndex].C7_QUJE.trim()) === 0 && Number(data[rowIndex].C7_QTDACLA.trim()) === 0 && data[rowIndex].C7_RESIDUO.trim() === '' )"
                        paginacao={200}
                    />
                </Col>
            </Row>
        </>
    );
}

export default ListaPedidosCompra;

//{isAlterar: true, action: handleCopiar, label: "Copiar", icone: "MdOutlineCopyAll", style: "success"},  Copiar Pedido